import PropTypes from 'prop-types';

var propTypes = {
    date: PropTypes.object,
    focused: PropTypes.bool,
    label: PropTypes.string,
};
var defaultProps = {
    numberOfMonths: 1,
};

export { defaultProps, propTypes };
